const DITypes = {
  JsonRpcDispatcher: Symbol('JsonRpcDispatcher'),
  JsonRpcDispatcherFactory: Symbol('JsonRpcDispatcherFactory'),
  AdapterFactory: Symbol('AdapterFactory'),
  DispatcherCache: Symbol('DispatcherCache'),
  AdapterCache: Symbol('AdapterCache'),
};

export default DITypes;
